<template>
  <div id="BuyerList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />
    </eb-header>
    <div class="list-box">
      <div class="card-box" v-for="item in listBuyer" :key="item.departId">
        <OrgBuyerCard @followSuccess="followSuccess" :orgInfo="item" :user="user"/>
      </div>
    </div>
    <eb-pagination :current-page.sync="pageNumber" v-if="paginationSize" @current-change="paginationData" :total="paginationSize"/>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import OrgBuyerCard from '@/components/org/view/OrgBuyerCard';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { listBuyer } from '@/services/user/user-supplier-service';
export default {
  name: 'SupplierList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    OrgBuyerCard,
    ebPagination
  },
  data() {
    return {
      listBuyer: null,
      paginationSize: null,
      user: this.$store.state.user.userInfo,
      listRequestData: {
        number: 10,
        page: 1,
        departName: '',
        sortParams: '',
        sortValue: null
      },
      pageNumber: 1
    };
  },
  created() {
    this.initList();
  },
  methods: {
    async initList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listBuyer(this.listRequestData);
        if (data.returnCode === '01') {
          this.listBuyer = data.supplierList;
          this.paginationSize = data.size;
        } else {
          this.$message.error('获取客户列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 初始化参数
    resetListRequestData() {
      this.listRequestData.page = 1;
      this.pageNumber = 1;
    },
    // 点击搜索
    searchData: function(data) {
      this.resetListRequestData();
      this.listRequestData.departName = data;
      this.initList();
    },
    // 点击分页
    paginationData: function(data) {
      this.listRequestData.page = data;
      this.initList();
    },
    followSuccess: function() {
      this.initList();
    }
  }
};
</script>
<style scoped lang="less">
.card-box {
  padding-top: 30px;
}
.order-box {
  padding-left: 47px;
}
</style>
